import { 
  gql, 
  useQuery 
} from "@apollo/client";
import { 
    MerchantOverviewAdminQueryQuery, 
    MerchantOverviewAdminQueryQueryVariables 
} from "../../../../../schemaTypes";

export const merchantOverviewAdminQuery = gql`
  query MerchantOverviewAdminQuery(
    $id: String!
  ) {
    merchantOverviewAdmin(
      id: $id
    ) {
        redeemedOffers
        currentBalance
        amountReceived
        amountWithdrawn
    }
  }
`;

export interface WithMerchantOverviewAdmin {
  redeemedOffers: number;
  currentBalance: number;
  amountReceived: number;
  amountWithdrawn: number;
}

interface Props {
  variables: MerchantOverviewAdminQueryQueryVariables;
  children: (data: WithMerchantOverviewAdmin) => React.ReactElement | null;
}

export const MerchantOverviewAdminController: React.FC<Props> = ({ children, variables }) => {
  const { data } = useQuery<
    MerchantOverviewAdminQueryQuery,
    MerchantOverviewAdminQueryQueryVariables
  >(merchantOverviewAdminQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  const redeemedOffers = data?.merchantOverviewAdmin?.redeemedOffers || 0;
  const currentBalance = data?.merchantOverviewAdmin?.currentBalance || 0;
  const amountReceived = data?.merchantOverviewAdmin?.amountReceived || 0;
  const amountWithdrawn = data?.merchantOverviewAdmin?.amountWithdrawn || 0;


  return children({
        redeemedOffers,
        currentBalance,
        amountReceived,
        amountWithdrawn
  });
};